import type { Nullable } from 'corgi-types';

import type { GiftCardStatus } from '../types/gift-card';

export const isValidGiftCardStatus = (status: Nullable<GiftCardStatus>): status is GiftCardStatus =>
  status !== null;
